import React from 'react';
import { TextField } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import { useFormOperations } from '../../hooks/useFormOperations';
import { inputStyles } from '../styles';
import { useFormContext } from '../../context/FormContext';

interface NameFieldProps {
  type: 'template' | 'stack';
}

const NameField: React.FC<NameFieldProps> = ({ type }) => {
  const { name, setName } = useFormOperations();
  const { state } = useFormContext();
  const { hasAttemptedSubmit } = state;
  return (
    <Grid2 size={12} sx={{ mb: 2 }}>
      <TextField
        fullWidth
        label={`${type === 'template' ? 'Template' : 'Stack'} Name`}
        value={name}
        onChange={(e) => setName(e.target.value)}
        variant='outlined'
        size='small'
        required
        error={hasAttemptedSubmit && !name.trim()}
        helperText={
          hasAttemptedSubmit && !name.trim()
            ? `${type === 'template' ? 'Template' : 'Stack'} name is required`
            : ''
        }
        sx={inputStyles}
      />
    </Grid2>
  );
};

export default NameField;
